import { Brand, Contract, ContractDataWithLinks, FinancialDetails } from 'cpie-common';
import { AbstractContractBasedDataState } from '@cp-shared-15/frontend-integration/build/contractBasedDataFetchSlice';
import { DefaultBusinessMarketApiErrorCode } from '@cp-shared-15/common-utilities';

type ContractWithBrand = Contract & { brand: Brand };

export type GroupedContractsByVin = Array<ContractDataWithLinks[]>;

export const getMostRecentContractWithBrand = (contracts: Contract[] | undefined): ContractWithBrand | undefined => {
    const contractsWithBrand: ContractWithBrand[] = (contracts?.filter(contract => !!contract.brand) ||
        []) as ContractWithBrand[];

    if (!contractsWithBrand?.length) return undefined;
    return contractsWithBrand.sort((a, b) => ((a.startDate || '') > (b.startDate || '') ? -1 : 1))[0];
};

export const areContractsOneBrand = (contracts?: Contract[] | undefined): boolean | undefined => {
    return contracts?.every(item => item.brand === contracts[0].brand);
};

export const findActiveContractWithLatestEndDate = (contracts?: Contract[]): Contract | undefined => {
    if (!contracts?.length) {
        return;
    }

    return contracts
        .filter(contract => contract.isActive)
        .reduce((a, b) => ((a.endDate || '') < (b.endDate || '') ? a : b));
};

export const groupContractsByVin = (contracts: ContractDataWithLinks[]): GroupedContractsByVin => {
    return contracts.reduce((acc: GroupedContractsByVin, current) => {
        const groupIndex = acc.findIndex(group => group.some(contract => contract.vin === current.vin));
        if (groupIndex > -1) {
            acc[groupIndex].push(current);
        } else {
            acc.push([current]);
        }
        return acc;
    }, []);
};

export const isBankLeavingIban = (iban: string) => {
    return /^.*(ICON|ULSB).*$/g.test(iban);
};

export const getAllActiveContractsIbans = (
    financialDetails: AbstractContractBasedDataState<FinancialDetails, DefaultBusinessMarketApiErrorCode>,
): string[] =>
    Object.values(financialDetails)
        .map(({ data }) => (data?.isActive ? data?.iban : undefined))
        .filter(Boolean) as string[];
